// extracted by mini-css-extract-plugin
export default {"container":"BottomNav_container__e2Qpx","hamburger_icon_active":"BottomNav_hamburger_icon_active__4rNLv","hamburger_icon":"BottomNav_hamburger_icon__Z5N5T"};